module.exports = __webpack_public_path__ + "static/media/spinner.f974386c.gif";